// src/context/PostHogContext.js
import React, { createContext, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import posthog from 'posthog-js';

const PostHogContext = createContext(null);

// Initialize PostHog
const initPostHog = () => {
    const apiKey = process.env.REACT_APP_POSTHOG_KEY;
    const apiHost = process.env.REACT_APP_POSTHOG_HOST || 'https://eu.i.posthog.com';

    if (apiKey && !posthog.__loaded) {
        posthog.init(apiKey, {
            api_host: apiHost,
            person_profiles: 'identified_only',
            capture_pageview: false, // We'll handle this manually for SPA
            capture_pageleave: true,
        });
    }
};

// Component that tracks page views on route changes
const PostHogPageviewTracker = () => {
    const location = useLocation();

    useEffect(() => {
        if (posthog.__loaded) {
            posthog.capture('$pageview', {
                $current_url: window.location.href,
            });
        }
    }, [location]);

    return null;
};

export const PostHogProvider = ({ children }) => {
    useEffect(() => {
        initPostHog();
    }, []);

    return (
        <PostHogContext.Provider value={posthog}>
            <PostHogPageviewTracker />
            {children}
        </PostHogContext.Provider>
    );
};

export const usePostHog = () => {
    return useContext(PostHogContext);
};

export default posthog;
